import { useState } from "react";
import api, { API } from "@/lib/api";
import { PageHeader } from "@/components/pcp";
import { DownloadSimple, FileArrowDown, ChartLineUp } from "@phosphor-icons/react";
import { toast } from "sonner";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";

export default function Relatorios() {
  const [tab, setTab] = useState("bdp");
  const hoje = new Date().toISOString().slice(0, 10);
  const [data, setData] = useState(hoje);
  const [inicio, setInicio] = useState(hoje);
  const [fim, setFim] = useState(hoje);
  const [bdp, setBdp] = useState(null);
  const [medicao, setMedicao] = useState(null);
  const [curvaS, setCurvaS] = useState(null);

  const carregarBDP = async () => {
    const { data: d } = await api.get(`/relatorios/bdp?data=${data}`);
    setBdp(d);
  };
  const carregarMedicao = async () => {
    const { data: d } = await api.get(`/relatorios/medicao?inicio=${inicio}&fim=${fim}`);
    setMedicao(d);
  };
  const carregarCurvaS = async () => {
    const { data: d } = await api.get(`/relatorios/curva_s`);
    setCurvaS(d);
  };

  const downloadMedicao = async () => {
    const token = localStorage.getItem("pcp_token");
    const r = await fetch(`${API}/relatorios/medicao/excel?inicio=${inicio}&fim=${fim}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) { toast.error("Erro ao baixar"); return; }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `medicao_${inicio}_${fim}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <PageHeader testid="page-relatorios" title="Relatórios" subtitle="Boletim diário, medição, curva S" />
      <div className="page-body">
        <div style={{ display: "flex", gap: 4, marginBottom: 24, borderBottom: "1px solid #E4E4E7" }}>
          {[["bdp", "Boletim Diário"], ["medicao", "Medição"], ["curva", "Curva S"]].map(([k, l]) => (
            <button
              key={k}
              className="btn btn-ghost"
              onClick={() => setTab(k)}
              data-testid={`tab-${k}`}
              style={{
                borderRadius: 0,
                borderBottom: tab === k ? "3px solid #FFCC00" : "3px solid transparent",
                color: tab === k ? "#0A0A0A" : "#71717A",
                fontWeight: 700,
              }}
            >{l}</button>
          ))}
        </div>

        {tab === "bdp" && (
          <div className="pcp-card" style={{ padding: 20 }}>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-end", marginBottom: 16 }}>
              <div><label className="label">Data</label><input type="date" className="input" value={data} onChange={(e) => setData(e.target.value)} /></div>
              <button className="btn btn-primary" onClick={carregarBDP} data-testid="btn-gerar-bdp"><ChartLineUp size={16} weight="bold" /> Gerar BDP</button>
            </div>
            {bdp && (
              <>
                <h3 className="font-display font-bold text-lg mb-3">Apontamentos em {new Date(data).toLocaleDateString("pt-BR")}</h3>
                {bdp.apontamentos.length === 0 ? (
                  <div style={{ color: "#71717A", padding: 16 }}>Sem produção neste dia.</div>
                ) : (
                  <table className="pcp-table">
                    <thead><tr><th>Data</th><th>OS</th><th>Item</th><th style={{ textAlign: "right" }}>Qtd</th><th>Observação</th></tr></thead>
                    <tbody>{bdp.apontamentos.map((a) => (
                      <tr key={a.id}><td className="font-mono text-xs">{new Date(a.data_execucao).toLocaleTimeString("pt-BR")}</td><td className="font-mono">{a.os_id.slice(0, 8)}</td><td>{a.item_id.slice(0, 8)}</td><td className="font-mono" style={{ textAlign: "right" }}>{a.quantidade}</td><td>{a.observacao}</td></tr>
                    ))}</tbody>
                  </table>
                )}
              </>
            )}
          </div>
        )}

        {tab === "medicao" && (
          <div className="pcp-card" style={{ padding: 20 }}>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-end", marginBottom: 16, flexWrap: "wrap" }}>
              <div><label className="label">Início</label><input type="date" className="input" value={inicio} onChange={(e) => setInicio(e.target.value)} /></div>
              <div><label className="label">Fim</label><input type="date" className="input" value={fim} onChange={(e) => setFim(e.target.value)} /></div>
              <button className="btn btn-primary" onClick={carregarMedicao} data-testid="btn-gerar-medicao">Gerar</button>
              <button className="btn btn-outline" onClick={downloadMedicao}><DownloadSimple size={16} weight="bold" /> Excel</button>
            </div>
            {medicao && (
              <table className="pcp-table">
                <thead><tr><th>OS</th><th>Contratante</th><th>Descrição</th><th>Unid.</th><th style={{ textAlign: "right" }}>Planejado</th><th style={{ textAlign: "right" }}>Executado</th></tr></thead>
                <tbody>{medicao.map((m, i) => (
                  <tr key={i}><td className="font-mono">{m.os_numero}</td><td>{m.contratante}</td><td>{m.descricao}</td><td>{m.unidade}</td><td className="font-mono" style={{ textAlign: "right" }}>{m.qtd_planejada}</td><td className="font-mono" style={{ textAlign: "right" }}>{m.qtd_executada.toFixed(2)}</td></tr>
                ))}</tbody>
              </table>
            )}
          </div>
        )}

        {tab === "curva" && (
          <div className="pcp-card" style={{ padding: 20 }}>
            <div style={{ marginBottom: 16 }}>
              <button className="btn btn-primary" onClick={carregarCurvaS} data-testid="btn-gerar-curva">Gerar Curva S</button>
            </div>
            {curvaS && curvaS.length > 0 && (
              <ResponsiveContainer width="100%" height={320}>
                <LineChart data={curvaS}>
                  <CartesianGrid stroke="#F4F4F5" />
                  <XAxis dataKey="data" tick={{ fontSize: 11 }} />
                  <YAxis tick={{ fontSize: 11 }} />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="diario" stroke="#0055FF" name="Diário" strokeWidth={2} />
                  <Line type="monotone" dataKey="acumulado" stroke="#0A0A0A" name="Acumulado" strokeWidth={3} />
                </LineChart>
              </ResponsiveContainer>
            )}
            {curvaS && curvaS.length === 0 && <div style={{ color: "#71717A", padding: 24, textAlign: "center" }}>Sem apontamentos para gerar curva.</div>}
          </div>
        )}
      </div>
    </>
  );
}
